<footer class="nina-footer">

    <div class="nina-footer__content">

        <!-- =====================================================
         MARCA
         ===================================================== -->

        <div class="nina-footer__brand">

            <img class="nina-footer__logo" src="assets/logos-nina/nina-logo-white.png" alt="Nina Pastelería"
                routerLink="/home" />

            <p class="nina-footer__slogan">
                La vida sabe <span class="nina-brand-italic">a Nina</span>
            </p>

            <p class="nina-footer__since">
                Desde 1987 en La Comarca Lagunera
            </p>

            <div class="nina-footer__social">

                <!-- Instagram -->
                <a href="https://www.instagram.com/ninapasteleria/" class="nina-footer__social-button"
                    aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                    <mat-icon>camera_alt</mat-icon>
                </a>

                <!-- Facebook -->
                <a href="https://www.facebook.com/ninapastelerias" class="nina-footer__social-button"
                    aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                    <mat-icon>facebook</mat-icon>
                </a>

            </div>

        </div>


        <!-- =====================================================
         SITIO
         ===================================================== -->

        <div class="nina-footer__column">

            <h3>SITIO</h3>

            <a routerLink="/store">
                Catálogo
            </a>

            <a routerLink="/promotions">
                Promociones
            </a>

            <a routerLink="/branches">
                Sucursales
            </a>

            <a routerLink="/history" *ngIf="tokenSSLoged">
                Pedidos
            </a>

            <!--
      <a routerLink="/facturacion">
        Facturación
      </a>
      -->

        </div>


        <!-- =====================================================
         SUCURSALES
         ===================================================== -->

        <div class="nina-footer__column">

            <h3>SUCURSALES</h3>

            <a routerLink="/branches">
                Ver sucursales
            </a>

            <p>
                Matriz · Av. Juárez 3090 Ote.
            </p>

            <p>
                Torreón · Gómez Palacio · Lerdo
            </p>

        </div>


        <!-- =====================================================
         AYUDA
         ===================================================== -->

        <div class="nina-footer__column">

            <h3>AYUDA</h3>

            <!--
      <a routerLink="/contacto">
        Contáctanos
      </a>
      -->

            <!--
      <a routerLink="/facturacion">
        Facturación
      </a>
      -->

            <!--
      <a routerLink="/bolsa-trabajo">
        Bolsa de trabajo
      </a>
      -->

            <a href="https://ninapasteleria.com/AvisoPrivacidad.html" target="_blank" rel="noopener noreferrer">
                Aviso de privacidad
            </a>

            <a href="https://ninapasteleria.com/tycnina.html" target="_blank" rel="noopener noreferrer">
                Términos y condiciones
            </a>

            <a routerLink="/history">
                Ayuda con mi pedido
            </a>

        </div>


        <!-- =====================================================
         CONTACTO
         ===================================================== -->

        <div class="nina-footer__column nina-footer__contact">

            <h3>CONTACTO</h3>

            <p>
                WhatsApp:
                <a href="https://wa.me/528715351045 " target="_blank" rel="noopener noreferrer">
                    (+52) 871 535 1045 
                </a>
            </p>

            <a href="mailto:clientes@pasteleriasnina.com">
                clientes@pasteleriasnina.com
            </a>

            <p>
                Av. Juárez 3090 Ote., Col. Centro,<br />
                CP 27000, Torreón, Coahuila, México
            </p>

        </div>

    </div>


    <!-- =====================================================
       COPYRIGHT
       ===================================================== -->

    <div class="nina-footer__bottom">

        <p>
            © 2026 NINA Pastelerías® · Gasa Fabricaciones SA de CV ·
            Torreón, Coahuila
        </p>

        <p>
            <a href="https://ninapasteleria.com/AvisoPrivacidad.html" target="_blank" rel="noopener noreferrer">
                Aviso de privacidad
            </a>

            · Los enlaces de WhatsApp abren wa.me en una pestaña nueva.
        </p>

    </div>

</footer>